import React from 'react';
import './App.css';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { Routes } from './components/router';
import { Footer } from './components/footer';

function App() {
  return (
    <div style={{ padding: 20}}>
      <Routes />
      <Footer />
    </div>
  );
}

export default App;
